import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import routes from "routes.js";
import { Layout, Row, Col } from "antd";
const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.layout === "/default") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    })}
  </Switch>
);

export default function NoAuth({ ...rest }) {

  return (
    <>
      <Layout >
       {switchRoutes}
      </Layout>
    </>
  );
}
